var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Logout",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M32,48a15.79,15.79,0,0,0,5.59-1.07,15.08,15.08,0,0,0,9.51-16,14.92,14.92,0,0,0-4.27-8.81,2.14,2.14,0,0,0-2.92-.21,2.08,2.08,0,0,0-.38,2.86c.24.35.55.66.83,1a10.32,10.32,0,0,1,2.48,8.57,10.9,10.9,0,1,1-19.18-8.56c.27-.32.56-.62.81-1a2.08,2.08,0,0,0-.37-2.92,2.14,2.14,0,0,0-2.89.2A14.87,14.87,0,0,0,17,35.47,15.16,15.16,0,0,0,32,48Zm2.14-22.26q0-3.81,0-7.62A2.07,2.07,0,0,0,31.78,16a2.1,2.1,0,0,0-1.9,2.1q0,7.64,0,15.28a2.12,2.12,0,0,0,4.25,0Q34.13,29.57,34.13,25.74Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/logout.svg